.panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-4);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-surface-elevated);
  text-align: center;
}

.header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--tuna-spacing-3);
  width: 100%;
}

.title {
  margin: 0;
  font-size: var(--tuna-typography-fontSize-xl);
}

.position {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-muted);
}

.body {
  margin: 0;
  max-width: 460px;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-muted);
}

.notes {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--tuna-spacing-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.note {
  padding: var(--tuna-spacing-1) var(--tuna-spacing-2);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  font-variant-numeric: tabular-nums;
  font-weight: 700;
}

.status {
  min-height: 1.5rem;
  font-size: var(--tuna-typography-body1-fontSize);
  font-weight: 700;
}

/* "Sing" is the one word that times the take: it reads from across the room, at full contrast */
.status[data-phase='listening'] {
  font-size: var(--tuna-typography-fontSize-4xl);
  line-height: 1.1;
  color: var(--tuna-content-primary);
}
